import { instance } from "../api/axiosInstance";
const axios = instance;

export async function fetchCityAdminsLists(pageNo = 1, pageSize = 10,selectedCityFilter = '', searchQuery = '') {
    return axios.get(`/users/management/cityAdminList?pageNo=${pageNo}&pageSize=${pageSize}&cityIds=${selectedCityFilter}&searchQuery=${searchQuery}`);
}
export async function fetchUserslists(pageNo = 1, pageSize = 10, searchQuery = '') {
    return axios.get(`/users/management/userList?pageNo=${pageNo}&pageSize=${pageSize}&searchQuery=${searchQuery}`);
}
export async function fetchSuperAdminsLists(pageNo = 1, pageSize = 10, selectedCityFilter = '', searchQuery = '') {
    return axios.get(`/users/management/superAdminList?pageNo=${pageNo}&pageSize=${pageSize}&cityIds=${selectedCityFilter}&searchQuery=${searchQuery}`);
}
export async function updateUsersRole(userId,payload) {
    return axios.patch(`/users/management/${userId}/role`,payload);
}

export async function updateUsersStatus(userId) {
    return axios.patch(`/users/management/${userId}/status`);
}